import React, {useEffect, useState} from "react";

const Countdown = ({event, content}) => {
    const [d1, setD1] = useState(0);
    const [d2, setD2] = useState(0);
    const [h1, setH1] = useState(0);
    const [h2, setH2] = useState(0);
    const [m1, setM1] = useState(0);
    const [m2, setM2] = useState(0);


    useEffect(() => {
        function startCounter(countDownDate) {
            // Update the countdown every 1 second

            var x = setInterval(function () {
                let now = new Date();

                // Find the distance between now and the countdown date
                let distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds

                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

                // Output the result in an element with id="demo"
                //document.getElementById("demo").innerHTML = days + "d " + hours + "h "
                //        + minutes + "m " + seconds + "s ";
                if (distance > 0) {
                    setD1(~~(days/10));
                    setD2(days % 10);
                    setH1(~~(hours / 10));
                    setH2(hours % 10);
                    setM1(~~(minutes / 10));
                    setM2(minutes % 10);
                } else {
                    setD1(0);
                    setD2(0);
                    setH1(0);
                    setH2(0);
                    setM1(0);
                    setM2(0);
                    clearInterval(x);
                }
            }, 1000)
            // Get today's date and time

        }

        startCounter(new Date((new Date(event.date)).toDateString() + " " + event.startTime));

    }, []);

    return(
        <div className="carousel-card-upper-section-right-container">
            <div className="flex column">
                <div className="countdown-container">
                    <div className="countdown-number-container">
                        <span>{d1}</span>
                    </div>
                    <div className="countdown-number-container">
                        <span>{d2}</span>
                    </div>
                </div>

                <span className="countdown-label">{content.days}</span>
            </div>
            <div className="countdown-colon-container">
                <span className="countdown-colon">:</span>
                <span className="countdown-colon-hidden">.</span>
            </div>
            <div className="flex column">
                <div className="countdown-container">
                    <div className="countdown-number-container">
                        <span>{h1}</span>
                    </div>
                    <div className="countdown-number-container">
                        <span>{h2}</span>
                    </div>
                </div>

                <span className="countdown-label">{content.hours}</span>
            </div>
            <div className="countdown-colon-container">
                <span className="countdown-colon">:</span>
                <span className="countdown-colon-hidden">.</span>
            </div>
            <div className="flex column">
                <div className="countdown-container">
                    <div className="countdown-number-container">
                        <span>{m1}</span>
                    </div>
                    <div className="countdown-number-container">
                        <span>{m2}</span>
                    </div>
                </div>

                <span className="countdown-label">{content.minutes}</span>
            </div>
        </div>
    )

}

export default Countdown;
